import React, { useState, useEffect } from 'react';
import {
  ArrowRight, TrendingUp, TrendingDown, Users,
  BarChart2, Target, BookOpen, CheckCircle,
  Clock, Award, Zap, ChevronDown, X, Star,
  Shield, Gift, AlertCircle, User, Building2,
  Rocket, Store,
  Mail,
  Database,
} from 'lucide-react';
import Footer from '../../Components/Footer';
import Header from '../../Components/Header';
import { Link } from 'react-router-dom';
import api from '../../api';
import peterDruckerImage from '../AbtestEbook/images/peter-drucker.jpg'; // 또는 .png
import surveyResult from '../AbtestEbook/images/survey-result.png'; // 또는 .png
import survey from '../AbtestEbook/images/survey.png'; // 또는 .png
import salaryBefore from '../AbtestEbook/images/salary-before.png'; // 또는 .png
import salaryAfter from '../AbtestEbook/images/salary-after.png'; // 또는 .png
import salaryBeforeMobile from '../AbtestEbook/images/salary-before-mobile.png'; // 또는 .png
import salaryAfterMobile from '../AbtestEbook/images/salary-after-mobile.png'; // 또는 .png

const AbtestEbookLandingPage = () => {
  const [scrolled, setScrolled] = useState(false);
  const [showMarketingModal, setShowMarketingModal] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [hasReceivedEbook, setHasReceivedEbook] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showExitPopup, setShowExitPopup] = useState(false);
  const [formData, setFormData] = useState({
    email: '',
    name: '',
    company: '',
    agreeToTerms: false,
    agreeToMarketing: false
  });

    
  // 전자책 받은 사람은 이탈 시 모달 안뜨게
  useEffect(() => {
    const ebookReceived = localStorage.getItem('ebookReceived');
    if (ebookReceived === 'true') {
      setHasReceivedEbook(true);
    }
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Exit Intent 감지
  useEffect(() => {
    const handleMouseLeave = (e) => {
      // 3. 전자책을 받은 사용자에게는 팝업을 보여주지 않음
      if (e.clientY <= 0 && !showExitPopup && !hasReceivedEbook) {
        setShowExitPopup(true);
      }
    };

    document.addEventListener('mouseleave', handleMouseLeave);
    return () => document.removeEventListener('mouseleave', handleMouseLeave);
  }, [showExitPopup, hasReceivedEbook]);

  const handleSubmit = async (e) => {
    e?.preventDefault();
    if (!formData.email) {
      alert('이메일 주소를 입력해주세요.');
      return;
    }

    if (!formData.agreeToTerms) {
      alert('전자책을 받으시려면 마케팅 정보 수신에 동의해주세요.');
      return;
    }

    try {
      setIsSubmitting(true);

      const response = await api.post('marketing/ebook-subscribe/',
        {
          email: formData.email,
          name: formData.name,
          company_name: formData.company

        }
      );
      setShowSuccessModal(true);

      setHasReceivedEbook(true);
      localStorage.setItem('ebookReceived', 'true');

      // Exit 팝업이 열려있다면 닫기
      if (showExitPopup) {
        setShowExitPopup(false);
      }
    } catch (error) {
      console.error('전자책 구독 중 오류 발생:', error);

      // 에러 타입에 따른 메시지 분기 처리
      if (error.response) {
        // 서버에서 응답은 왔지만 에러인 경우
        if (error.response.status === 400) {
          alert('입력하신 정보를 다시 확인해주세요.');
        } else if (error.response.status === 500) {
          alert('서버 오류가 발생했습니다. 잠시 후 다시 시도해주세요.');
        } else {
          alert('전자책 신청 중 오류가 발생했습니다. 다시 시도해주세요.');
        }
      } else if (error.request) {
        // 요청은 보냈지만 응답을 받지 못한 경우
        alert('네트워크 연결을 확인해주세요.');
      } else {
        // 요청 설정 중 오류가 발생한 경우
        alert('오류가 발생했습니다. 페이지를 새로고침 후 다시 시도해주세요.');
      }
    } finally {
      setIsSubmitting(false); // 제출 완료
    }
  };


  return (
    <div className="bg-white">
      <Header />

      {/* 성공 모달 */}
      {showSuccessModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
          <div className="bg-white rounded-2xl p-8 max-w-md w-full relative animate-bounce-in">
            <div className="text-center">
              {/* 성공 아이콘 */}
              <div className="mx-auto w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mb-6">
                <CheckCircle className="w-12 h-12 text-green-500" />
              </div>

              {/* 제목 */}
              <h3 className="text-2xl font-bold mb-4 text-gray-900">
                전자책 신청이 완료되었습니다!
              </h3>

              {/* 내용 */}
              <div className="space-y-3 mb-8">
                <p className="text-lg text-gray-700">
                  감사합니다, {formData.name || ''}님!
                </p>
                <p className="text-gray-600">
                  입력하신 이메일 주소로<br />
                  <span className="font-semibold text-blue-600">{formData.email}</span><br />
                  전자책이 발송되었습니다.
                </p>
                <div className="bg-blue-50 rounded-lg p-4 mt-4">
                  <p className="text-sm text-blue-800">
                    💡 이메일이 도착하지 않았다면 스팸함을 확인해주세요.
                  </p>
                </div>
              </div>

              {/* 확인 버튼 */}
              <button
                onClick={() => setShowSuccessModal(false)}
                className="w-full bg-gradient-to-r from-blue-600 to-indigo-600 text-white py-3 rounded-lg font-semibold hover:shadow-lg transition-all"
              >
                확인
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Exit Intent 팝업 */}
      {showExitPopup && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
          <div className="bg-white rounded-2xl p-8 max-w-lg w-full relative animate-bounce-in">
            <button
              onClick={() => setShowExitPopup(false)}
              className="absolute top-4 right-4 text-gray-400 hover:text-gray-600"
            >
              <X className="w-6 h-6" />
            </button>
            <div className="text-center">
              <Gift className="w-16 h-16 text-blue-600 mx-auto mb-4" />
              <h3 className="text-2xl font-bold mb-2">잠깐! 떠나지 마세요</h3>
              <p className="text-lg text-gray-600 mb-6">
                지금 이메일을 입력하시면<br />
                <span className="font-bold text-blue-600">무료 전자책</span>을 바로 받아보실 수 있습니다!
              </p>

              <form onSubmit={handleSubmit} className="space-y-4">
                <div>
                  <label className="block text-sm font-medium mb-2 text-left">
                    회사명 <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    required
                    className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                    placeholder="회사명을 입력하세요"
                    value={formData.company}
                    onChange={(e) => setFormData({ ...formData, company: e.target.value })}
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium mb-2 text-left">
                    이름 <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    required
                    className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                    placeholder="홍길동"
                    value={formData.name}
                    onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium mb-2 text-left">
                    이메일 <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="email"
                    required
                    className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                    placeholder="your@email.com"
                    value={formData.email}
                    onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                  />
                  <p className="text-xs text-gray-500 mt-1 text-left">
                    * 정확한 이메일 주소를 입력해주세요. 전자책이 이 주소로 발송됩니다.
                  </p>
                </div>

                {/* 개인정보 및 마케팅 통합 동의 - 필수 */}
                <div className="mt-4 text-left">
                  <label className="flex items-start">
                    <input
                      type="checkbox"
                      required
                      className="mt-1 mr-3 h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500 flex-shrink-0"
                      checked={formData.agreeToTerms}
                      onChange={(e) => setFormData({ ...formData, agreeToTerms: e.target.checked })}
                    />
                    <div className="flex-1">
                      <span className="text-[13px] sm:text-sm text-gray-600">
                        <Link to="/privacy" className="text-blue-600 hover:underline">
                          개인정보 처리방침
                        </Link> 및
                        <button
                          type="button"
                          onClick={() => setShowMarketingModal(true)}
                          className="text-blue-600 hover:underline ml-1"
                        >
                          마케팅 정보 수신
                        </button>
                        에 동의합니다 <span className="text-red-500">*</span>
                      </span>
                      <div className="text-xs text-gray-500 mt-1">
                        전자책 발송을 위해 필수로 동의가 필요합니다.
                      </div>
                    </div>
                  </label>
                </div>

                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="w-full bg-gradient-to-r from-blue-600 to-indigo-600 text-white py-3 rounded-lg font-semibold hover:shadow-lg transition-all"
                >
                  {isSubmitting ? '전송 중...' : '지금 이메일로 받기'}
                </button>
              </form>
            </div>
          </div>
        </div>
      )}

      {/* 헤더는 생략 (기존 Header 컴포넌트 사용) */}

      <div className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white py-3 text-center sticky top-16 z-30 shadow-lg">
        <div className="flex items-center justify-center space-x-6">
          <div className="flex items-center">
            <Users className="w-5 h-5 mr-2" />
            <span className="font-semibold">1,441명이 이미 전자책을 받았습니다</span>
          </div>
        </div>
      </div>

      {/* Hero Section - 실패와 성공 스토리 */}
      <section className="bg-gradient-to-br from-gray-900 via-gray-800 to-blue-900 text-white py-20 mt-16 relative overflow-hidden">
        <div className="absolute inset-0 opacity-20">
          <div className="absolute top-20 right-20 w-64 h-64 bg-red-500 rounded-full filter blur-3xl animate-pulse"></div>
          <div className="absolute bottom-10 left-10 w-96 h-96 bg-blue-600 rounded-full filter blur-3xl animate-pulse"></div>
        </div>

        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative">
          <div className="text-center">
            {/* 신뢰 요소 유지 - 위치를 조금 아래로 */}

            {/* 메인 스토리 - 실패부터 시작 */}
            <div className="mb-16">
              {/* Step 1: 실패 고백 */}
              <h1 className="text-4xl md:text-5xl font-bold mb-6 leading-tight">
                "전환율을 3%에서 1.5%로<br />
                <span className="text-red-400 text-5xl md:text-6xl">반토막</span> 냈습니다."
              </h1>

              <div className="flex items-center justify-center mb-8">
                <TrendingDown className="w-20 h-20 text-red-400 mr-4" />
                <div className="text-7xl font-bold text-red-400">-50%</div>
              </div>

              <p className="text-2xl text-gray-300 mb-12 font-semibold">
                "네, 제가 실패한 이야기입니다."
              </p>

              {/* 구분선 */}
              <div className="w-24 h-1 bg-gray-600 mx-auto mb-12"></div>

              {/* Step 2: 반전 */}
              <p className="text-3xl font-bold mb-8">
                "하지만 다시 전환율을<br />
                <span className="text-green-400 text-4xl md:text-5xl">4.3%</span>로
                <span className="text-green-400"> 2.8배</span><br className="sm:hidden" />
                <span className="inline-block">상승시켰습니다."</span>
              </p>

              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 mb-8 max-w-2xl mx-auto">
                <div className="flex items-center justify-center mb-4">
                  <TrendingUp className="w-16 h-16 text-green-400 mr-4" />
                  <div className="text-6xl font-bold text-green-400">+186%</div>
                </div>
                <p className="text-2xl font-bold text-yellow-400">
                  "한 달만에 월 매출 5억도<br className="sm:hidden" />
                  <span className="inline-block">달성했습니다."</span>
                </p>
              </div>

              <p className="text-xl text-gray-300 mb-12 italic">
                저의 실제 사례입니다.
              </p>

              {/* Step 3: 비밀 공개 */}
              <div className="bg-gradient-to-r from-blue-600/20 to-indigo-600/20 backdrop-blur-sm rounded-2xl p-8 max-w-3xl mx-auto mb-12">
                <p className="text-[22px] sm:text-2xl mb-4">
                  이런 성과를 어떻게 만들었을까요?
                </p>
                <p className="text-3xl font-bold text-blue-400">
                  바로 퍼포먼스 마케팅과 A/B 테스트입니다.
                </p>
              </div>

            </div>

            {/* CTA 버튼 - 더 강력하게 */}
            <button
              onClick={() => document.getElementById('ebook-form').scrollIntoView({ behavior: 'smooth' })}
              className="bg-gradient-to-r from-yellow-400 to-orange-500 text-gray-900 px-8 py-4 rounded-full font-bold text-lg hover:shadow-2xl transition-all duration-300 animate-pulse"
            >
              저와 같은 성과를 만들어보세요 →
            </button>

            {/* 스크롤 유도 */}
            <div className="mt-12 animate-bounce">
              <ChevronDown className="w-10 h-10 mx-auto text-gray-400" />
            </div>
          </div>
        </div>
      </section>

      {/* 가치 제안 섹션 - 비밀 공개 섹션과 통합 */}
      <section className="py-20 bg-gradient-to-b from-gray-50 to-white relative overflow-hidden">
        {/* 배경 장식 추가 */}
        <div className="absolute top-0 right-0 w-96 h-96 bg-blue-100 rounded-full filter blur-3xl opacity-30"></div>
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-purple-100 rounded-full filter blur-3xl opacity-30"></div>

        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative">
          {/* 섹션 타이틀 추가 */}
          <div className="text-center mb-16">
            <div className="inline-flex items-center bg-blue-100 text-blue-800 px-4 py-2 rounded-full font-semibold mb-6">
              <Zap className="w-5 h-5 mr-2" />
              성공의 비밀
            </div>

            <h2 className="text-[1.75rem] sm:text-3xl md:text-4xl font-bold mb-8">
              대부분의 마케터가 놓치고 있는 것
            </h2>

            <div className="max-w-3xl mx-auto">
              <p className="text-2xl mb-2 text-gray-700">
                여러분은 퍼포먼스 마케팅에 대해
              </p>
              <p className="text-2xl font-bold text-gray-900">
                얼마나 알고 계신가요?
              </p>
            </div>
          </div>

          {/* 일반적인 오해 - 더 강력한 시각적 효과 */}
          <div className="relative mb-16">
            <div className="max-w-4xl mx-auto">
              {/* 말풍선 스타일 */}
              <div className="relative bg-gray-100 rounded-3xl p-8 shadow-lg">
                <div className="absolute -top-6 left-1/2 transform -translate-x-1/2">
                  <div className="bg-yellow-400 rounded-full p-3">
                    <AlertCircle className="w-6 h-6 text-gray-900" />
                  </div>
                </div>

                <p className="text-[21px] sm:text-2xl text-center italic text-gray-600 font-medium">
                  "그거 그냥 광고 운영하는 거 아니야?"
                </p>

                {/* 물음표 장식 */}
                <div className="absolute -right-8 -top-8 text-6xl text-gray-300 opacity-50">?</div>
                <div className="absolute -left-6 -bottom-6 text-4xl text-gray-300 opacity-50 rotate-12">?</div>
              </div>
            </div>
          </div>

          {/* 진짜 퍼포먼스 마케팅 - 대비 효과 강화 */}
          <div className="relative mb-16">
            <div className="max-w-5xl mx-auto">
              {/* Before & After 스타일 */}
              <div className="grid md:grid-cols-2 gap-8">
                {/* 잘못된 인식 */}
                <div className="relative">
                  <div className="absolute -inset-2 bg-red-100 rounded-3xl transform rotate-2"></div>
                  <div className="relative bg-white rounded-2xl p-8 shadow-lg border-2 border-red-200">
                    <div className="text-center mb-4">
                      <X className="w-16 h-16 text-red-500 mx-auto" />
                    </div>
                    <h3 className="text-xl font-bold mb-3 text-center">일반적인 오해</h3>
                    <ul className="space-y-2 text-gray-600">
                      <li className="flex items-start">
                        <span className="text-red-500 mr-2">×</span>
                        광고 매체 운영
                      </li>
                      <li className="flex items-start">
                        <span className="text-red-500 mr-2">×</span>
                        키워드 입찰가 조정
                      </li>
                      <li className="flex items-start">
                        <span className="text-red-500 mr-2">×</span>
                        단순 광고비 집행
                      </li>
                    </ul>
                  </div>
                </div>

                {/* 올바른 이해 */}
                <div className="relative">
                  <div className="absolute -inset-2 bg-green-100 rounded-3xl transform -rotate-2"></div>
                  <div className="relative bg-white rounded-2xl p-8 shadow-lg border-2 border-green-200">
                    <div className="text-center mb-4">
                      <CheckCircle className="w-16 h-16 text-green-500 mx-auto" />
                    </div>
                    <h3 className="text-xl font-bold mb-3 text-center">진짜 퍼포먼스 마케팅</h3>
                    <ul className="space-y-2 text-gray-700">
                      <li className="flex items-start">
                        <span className="text-green-500 mr-2">✓</span>
                        데이터 기반 의사결정
                      </li>
                      <li className="flex items-start">
                        <span className="text-green-500 mr-2">✓</span>
                        A/B 테스트로 검증
                      </li>
                      <li className="flex items-start">
                        <span className="text-green-500 mr-2">✓</span>
                        지속적인 성과 개선
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* 성과 증명 */}
          <div className="text-center mb-16">
            <p className="text-3xl font-bold bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent">
              이것이 제가 월 매출 5억을<br />
              만든 비밀입니다.
            </p>
          </div>

          {/* 전자책 소개 - 시각적 강화 */}
          <div className="relative">
            <div className="absolute -inset-4 bg-gradient-to-r from-yellow-100 to-orange-100 rounded-3xl blur-xl opacity-50"></div>
            <div className="relative bg-gradient-to-r from-yellow-400 to-orange-400 p-1 rounded-3xl">
              <div className="bg-white rounded-2xl px-10 py-8">
                <p className="text-2xl font-bold text-center text-gray-900 mb-2">
                  <span className="hidden sm:inline">퍼포먼스 마케팅과 A/B 테스트를 통해</span>
                  <span className="sm:hidden">
                    퍼포먼스 마케팅과<br />
                    A/B 테스트를 통해
                  </span>
                </p>
                <p className="text-2xl font-bold text-center text-gray-900 mb-8">
                  <span className="hidden sm:inline">
                    큰 성과를 만드는 방법을 <span className="text-blue-600">무료 전자책</span>을 통해 알려드리려고 합니다.
                  </span>
                  <span className="sm:hidden">
                    큰 성과를 만드는 방법을<br />
                    <span className="text-blue-600">무료 전자책</span>을 통해<br />
                    알려드리려고 합니다.
                  </span>
                </p>

                {/* 핵심 내용 카드 */}
                <div className="grid md:grid-cols-3 gap-4 mt-8">
                  <div className="bg-green-50 rounded-xl p-6 text-center transform hover:scale-105 transition-transform">
                    <CheckCircle className="w-8 h-8 text-green-500 mx-auto mb-3" />
                    <p className="font-semibold text-gray-800">왜 전환율이<br />반토막났는지</p>
                  </div>
                  <div className="bg-blue-50 rounded-xl p-6 text-center transform hover:scale-105 transition-transform">
                    <CheckCircle className="w-8 h-8 text-blue-500 mx-auto mb-3" />
                    <p className="font-semibold text-gray-800">어떻게 다시 전환율을<br />4.3%까지 끌어올렸는지</p>
                  </div>
                  <div className="bg-purple-50 rounded-xl p-6 text-center transform hover:scale-105 transition-transform">
                    <CheckCircle className="w-8 h-8 text-purple-500 mx-auto mb-3" />
                    <p className="font-semibold text-gray-800">A/B 테스트를<br />실제로 어떻게 활용하는지</p>
                  </div>
                </div>

                <p className="text-xl font-bold text-center text-blue-600 mt-8">
                  <span className="hidden sm:inline">초보자도, 경험자도 바로 적용할 수 있는 실전 노하우를 담았습니다.</span>
                  <span className="sm:hidden">
                    초보자도, 경험자도 바로 적용할 수<br />
                    있는 실전 노하우를 담았습니다.
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 전자책 내용 미리보기 섹션 */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl font-bold mb-6">
              이 전자책에서 배우게 될 내용
            </h2>
            <p className="text-xl text-gray-600">
              3개 챕터 + 에필로그로 구성된 실전 가이드북
            </p>
          </div>

          <div className="space-y-8">
            {/* Chapter 1 */}
            <div className="bg-white rounded-2xl shadow-lg p-8 border-2 border-gray-100 hover:border-blue-200 transition-colors">
              <div className="mb-6">
                <span className="text-sm font-bold text-blue-600 bg-blue-50 px-3 py-1 rounded-full">Chapter 1</span>
                <h3 className="text-2xl font-bold mt-3">퍼포먼스 마케팅의 기초</h3>
              </div>
              <ul className="space-y-3">
                <li className="flex items-start">
                  <CheckCircle className="w-5 h-5 text-green-500 mr-3 flex-shrink-0 mt-0.5" />
                  <span className="text-gray-700">퍼포먼스 마케팅 노하우를 공개합니다</span>
                </li>
                <li className="flex items-start">
                  <CheckCircle className="w-5 h-5 text-green-500 mr-3 flex-shrink-0 mt-0.5" />
                  <span className="text-gray-700">퍼포먼스 마케팅이란?</span>
                </li>
                <li className="flex items-start">
                  <CheckCircle className="w-5 h-5 text-green-500 mr-3 flex-shrink-0 mt-0.5" />
                  <span className="text-gray-700">퍼포먼스 마케팅에서 우리가 해야 할 것</span>
                </li>
                <li className="flex items-start">
                  <CheckCircle className="w-5 h-5 text-green-500 mr-3 flex-shrink-0 mt-0.5" />
                  <span className="text-gray-700">마케팅에서 데이터를 활용하는 것이 효과적인 이유</span>
                </li>
                <li className="flex items-start">
                  <CheckCircle className="w-5 h-5 text-green-500 mr-3 flex-shrink-0 mt-0.5" />
                  <span className="text-gray-700">퍼포먼스 마케팅과 그로스 해킹</span>
                </li>
              </ul>
            </div>

            {/* Chapter 2 */}
            <div className="bg-white rounded-2xl shadow-lg p-8 border-2 border-gray-100 hover:border-blue-200 transition-colors">
              <div className="mb-6">
                <span className="text-sm font-bold text-blue-600 bg-blue-50 px-3 py-1 rounded-full">Chapter 2</span>
                <h3 className="text-2xl font-bold mt-3">퍼포먼스 마케팅 핵심</h3>
              </div>
              <div className="space-y-4">
                <div className="flex items-start">
                  <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0 mr-3">
                    <span className="text-sm font-bold text-blue-600">★</span>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-1">성장을 만드는 퍼포먼스 마케팅의 핵심 원리</h4>
                    <p className="text-gray-600 text-sm">제가 월 매출 5억을 달성한 핵심 전략을 공개합니다</p>
                  </div>
                </div>

                <div className="ml-11 space-y-3">
                  <div className="flex items-center">
                    <span className="text-blue-600 font-bold mr-2">1.</span>
                    <span className="text-gray-700">새로운 데이터 모으기</span>
                  </div>
                  <div className="flex items-center">
                    <span className="text-blue-600 font-bold mr-2">2.</span>
                    <span className="text-gray-700">개선 데이터 찾기</span>
                  </div>
                  <div className="flex items-center">
                    <span className="text-blue-600 font-bold mr-2">3.</span>
                    <span className="text-gray-700">개선 방법 찾기</span>
                  </div>
                  <div className="flex items-center">
                    <span className="text-blue-600 font-bold mr-2">4.</span>
                    <span className="text-gray-700">실행하기</span>
                  </div>
                  <div className="flex items-center">
                    <span className="text-blue-600 font-bold mr-2">5.</span>
                    <span className="text-gray-700">결과 분석</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Chapter 3 */}
            <div className="bg-white rounded-2xl shadow-lg p-8 border-2 border-gray-100 hover:border-blue-200 transition-colors relative overflow-hidden">
              <div className="absolute top-0 right-0 bg-gradient-to-bl from-yellow-100 to-transparent w-32 h-32"></div>
              <div className="mb-6">
                <span className="text-sm font-bold text-blue-600 bg-blue-50 px-3 py-1 rounded-full">Chapter 3</span>
                <h3 className="text-2xl font-bold mt-3">가설을 성과로 바꾸는 A/B 테스트</h3>
              </div>
              <ul className="space-y-3">
                <li className="flex items-start">
                  <Zap className="w-5 h-5 text-yellow-500 mr-2 flex-shrink-0 mt-0.5" />
                  <span className="text-gray-700">퍼포먼스 마케팅의 핵심과 A/B 테스트</span>
                </li>
                <li className="flex items-start">
                  <Zap className="w-5 h-5 text-yellow-500 mr-2 flex-shrink-0 mt-0.5" />
                  <span className="text-gray-700">모든 것의 시작, 명확한 가설 세우기</span>
                </li>
                <li className="flex items-start">
                  <Zap className="w-5 h-5 text-yellow-500 mr-2 flex-shrink-0 mt-0.5" />
                  <span className="text-gray-700">신뢰도 높은 실험을 위한 테스트 설계</span>
                </li>
                <li className="flex items-start">
                  <Zap className="w-5 h-5 text-yellow-500 mr-2 flex-shrink-0 mt-0.5" />
                  <span className="text-gray-700">A/B 테스트 실행과 결과 분석</span>
                </li>
              </ul>
              <div className="mt-4 p-3 bg-yellow-50 rounded-lg">
                <p className="text-sm font-semibold text-gray-800">
                  💡 전환율 1.5% → 4.3%를 만든 실제 A/B 테스트 사례 포함
                </p>
              </div>
            </div>

            {/* 에필로그 */}
            <div className="bg-gradient-to-r from-blue-600 to-indigo-600 rounded-2xl shadow-xl p-8 text-white relative">
              <div className="absolute top-4 right-4">
                <Award className="w-8 h-8 text-yellow-400" />
              </div>
              <div className="mb-4">
                <span className="text-sm font-bold bg-white/20 px-3 py-1 rounded-full">에필로그</span>
              </div>
              <h3 className="text-2xl font-bold mb-3">
                <span className="hidden sm:inline">이제, A/B 테스트를 직접 시작할 시간</span>
                <span className="sm:hidden">
                  이제, A/B 테스트를<br />
                  직접 시작할 시간
                </span>
              </h3>
              <p className="text-blue-100">
                읽기만 하지 말고, 실행하세요. 당신의 비즈니스도 성장할 수 있습니다.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* 저자 스토리 섹션 */}
      <section className="py-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* 어두운 과거 스토리 */}
          <div className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 rounded-3xl p-12 text-white relative overflow-hidden shadow-2xl">
            {/* 배경 장식 */}
            <div className="absolute top-0 right-0 w-64 h-64 bg-red-500 rounded-full filter blur-3xl opacity-10"></div>
            <div className="absolute bottom-0 left-0 w-48 h-48 bg-gray-600 rounded-full filter blur-3xl opacity-10"></div>

            <div className="relative space-y-6">
              {/* 년도 강조 */}
              <div className="inline-flex items-center bg-red-500/20 backdrop-blur-sm rounded-full px-4 py-2 mb-4">
                <span className="text-red-400 font-bold">2017년</span>
              </div>

              <h3 className="text-3xl md:text-4xl font-bold leading-tight">
                저는 하루 종일<br className="sm:hidden" />
                <span className="inline-block">전화 영업만 하는</span><br />
                신입 마케터였습니다.
              </h3>


              <p className="text-xl text-gray-300">
                하지만, 실제로 하는 것은 고작 검색 광고 키워드 만들기와 입찰가 조정 뿐이었습니다.
              </p>

              <div className="bg-gray-800/50 rounded-lg p-4 border-l-4 border-gray-600">
                <p className="text-lg italic text-gray-400">
                  그러면서 <span className="text-white font-semibold">"이게 정말 마케팅인가?"</span> 고민했죠.
                </p>
              </div>
            </div>
          </div>

          {/* 변화의 순간 - 화살표 */}
          <div className="flex justify-center my-8">
            <div className="relative">
              <div className="absolute inset-0 bg-gradient-to-b from-gray-400 to-green-400 blur-lg opacity-50"></div>
              <TrendingUp className="relative w-16 h-16 text-green-500 animate-bounce" />
            </div>
          </div>

          {/* 밝은 현재 스토리 */}
          <div className="bg-gradient-to-br from-blue-50 via-white to-yellow-50 rounded-3xl p-12 shadow-2xl relative overflow-hidden">
            {/* 배경 장식 */}
            <div className="absolute top-0 right-0 w-64 h-64 bg-yellow-300 rounded-full filter blur-3xl opacity-20"></div>
            <div className="absolute bottom-0 left-0 w-48 h-48 bg-blue-300 rounded-full filter blur-3xl opacity-20"></div>

            <div className="relative text-center space-y-6">
              <h3 className="text-2xl sm:text-3xl md:text-4xl font-bold bg-gradient-to-r from-yellow-600 to-orange-600 bg-clip-text text-transparent">
                그런데 지금은 월 매출 5억을 만듭니다.
              </h3>

              <p className="text-2xl text-gray-700 font-medium">
                무엇이 달라졌을까요?
              </p>

              <div className="inline-block bg-gradient-to-r from-blue-500 to-indigo-600 p-1 rounded-2xl">
                <div className="bg-white rounded-xl px-8 py-4">
                  <p className="text-lg md:text-xl font-bold text-gray-900">
                    <span className="hidden sm:inline">
                      바로 <span className="text-blue-600">'진짜'</span> 퍼포먼스 마케팅과 A/B 테스트를 알게 되었기 때문입니다.
                    </span>
                    <span className="sm:hidden">
                      바로 <span className="text-blue-600">'진짜'</span> 퍼포먼스 마케팅과<br />
                      A/B 테스트를 알게 되었기<br />
                      때문입니다.
                    </span>
                  </p>

                </div>
              </div>
            </div>
          </div>

          {/* 독자에게 전하는 메시지 */}
          <div className="mt-12 bg-white rounded-2xl shadow-xl p-10 border-2 border-gray-100">
            <p className="text-2xl font-bold text-center mb-8">
              만약 여러분도
            </p>

            <div className="grid md:grid-cols-3 gap-4 mb-10">
              <div className="text-center p-6 rounded-xl bg-red-50 border-2 border-red-200">
                <div className="w-12 h-12 bg-red-500 rounded-full flex items-center justify-center mx-auto mb-3">
                  <span className="text-white text-2xl">💸</span>
                </div>
                <p className="text-lg font-semibold text-gray-800">"광고비만 태우고 있다"</p>
              </div>
              <div className="text-center p-6 rounded-xl bg-orange-50 border-2 border-orange-200">
                <div className="w-12 h-12 bg-orange-500 rounded-full flex items-center justify-center mx-auto mb-3">
                  <span className="text-white text-2xl">📊</span>
                </div>
                <p className="text-lg font-semibold text-gray-800">"성과가 정체되어 있다"</p>
              </div>
              <div className="text-center p-6 rounded-xl bg-green-50 border-2 border-green-200">
                <div className="w-12 h-12 bg-green-500 rounded-full flex items-center justify-center mx-auto mb-3">
                  <span className="text-white text-2xl">🚀</span>
                </div>
                <p className="text-lg font-semibold text-gray-800">"더 큰 성장을 원한다"</p>
              </div>
            </div>

            <p className="text-xl text-center text-gray-600 mb-4">
              이런 고민을 하고 있다면,
            </p>

            <p className="text-3xl font-bold text-center bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent">
              <span className="hidden sm:inline">제가 걸어온 길을 공유하겠습니다.</span>
              <span className="sm:hidden">
                제가 걸어온 길을<br />
                공유하겠습니다.
              </span>
            </p>
          </div>
        </div>
      </section>

      {/* 설문조사 결과 섹션 */}
      <section className="py-20 bg-gradient-to-br from-gray-50 to-blue-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* 설문조사 이미지 1 */}
          <div className="mb-12">
            <div className="bg-white rounded-2xl shadow-xl p-8 border-2 border-gray-100">
              <div className="flex items-center justify-center h-64 sm:h-80 bg-gradient-to-br from-gray-100 to-gray-50 rounded-lg mb-6 overflow-hidden">
                <img
                  src={survey}
                  alt="설문조사 차트"
                  className="w-full h-full object-contain p-2 sm:p-4"
                />
              </div>

              <h3 className="text-3xl font-bold text-center mb-4">
                실제 마케터와 사업가 289명에게 물었습니다.
              </h3>
              <p className="text-[22px] sm:text-2xl text-center text-gray-700">
                "지금 가장 필요한 마케팅 역량은?"
              </p>
            </div>
          </div>

          {/* 설문조사 결과 - 시각적 강조 */}
          <div className="mb-16">
            <div className="bg-gradient-to-r from-blue-600 to-indigo-600 rounded-3xl p-1">
              <div className="bg-white rounded-2xl p-10">
                {/* 차트 영역 */}
                <div className="mb-8">
                  <div className="mb-8">
                    <div className="flex items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-50 rounded-lg mb-6 p-4">
                      <img
                        src={surveyResult}
                        alt="설문조사 결과 차트"
                        className="max-w-full h-auto"
                      />
                    </div>
                  </div>
                </div>

                {/* 1위 결과 강조 */}
                <div className="text-center mb-8">
                  <div className="inline-flex items-center bg-gradient-to-r from-yellow-400 to-orange-400 text-white px-6 py-3 rounded-full font-bold text-lg mb-4">
                    <Award className="w-6 h-6 mr-2" />
                    1위
                  </div>
                  <h4 className="text-3xl font-bold text-gray-900 mb-4">
                    데이터, 퍼포먼스 마케팅
                  </h4>
                  <div className="relative w-full max-w-md mx-auto">
                    <div className="bg-gray-200 rounded-full h-8">
                      <div className="bg-gradient-to-r from-blue-500 to-indigo-600 h-8 rounded-full flex items-center justify-end pr-4" style={{ width: '68%' }}>
                        <span className="text-white font-bold">68%</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* 역설적 상황 */}
          <div className="mb-12 text-center space-y-6">
            <p className="text-[22px] sm:text-2xl font-semibold text-gray-700">
              그런데 정작 제대로 아는 사람은 드뭅니다.
            </p>

            <div className="bg-gray-100 rounded-2xl p-8 max-w-3xl mx-auto">
              <p className="text-2xl text-gray-800 mb-2">
                <span className="hidden sm:inline">"퍼포먼스 마케팅으로 큰 성과 냈다"는 사람,</span>
                <span className="sm:hidden">
                  "퍼포먼스 마케팅으로<br />
                  큰 성과 냈다"는 사람,
                </span>
              </p>
              <p className="text-2xl font-bold text-gray-900">
                주변에 있으신가요?
              </p>
            </div>
          </div>

          {/* 저자의 답변 - 강력한 마무리 */}
          <div className="relative">
            <div className="absolute -inset-4 bg-gradient-to-r from-blue-100 to-indigo-100 rounded-3xl blur-2xl opacity-70"></div>
            <div className="relative bg-white rounded-3xl shadow-2xl p-10 text-center">
              <p className="text-3xl font-bold mb-8">
                저는 있습니다.<br />
                <span className="text-blue-600 text-4xl">
                  <span className="hidden sm:inline">바로 제가 그 사람이니까요.</span>
                  <span className="sm:hidden">
                    바로 제가 그 사람<br />
                    이니까요.
                  </span>
                </span>
              </p>

              {/* 성과 증명 */}
              <div className="grid md:grid-cols-2 gap-6 mb-8">
                <div className="bg-green-50 rounded-xl p-6 border-2 border-green-200">
                  <CheckCircle className="w-8 h-8 text-green-500 mx-auto mb-2" />
                  <p className="text-xl font-bold text-gray-900">전환율</p>
                  <p className="text-2xl font-bold">
                    <span className="text-red-500">1.5%</span>
                    <ArrowRight className="inline w-5 h-5 mx-2" />
                    <span className="text-green-600">4.3%</span>
                  </p>
                </div>
                <div className="bg-yellow-50 rounded-xl p-6 border-2 border-yellow-200">
                  <CheckCircle className="w-8 h-8 text-yellow-500 mx-auto mb-2" />
                  <p className="text-xl font-bold text-gray-900">월 매출</p>
                  <p className="text-3xl font-bold text-blue-600">5억 달성</p>
                </div>
              </div>

              {/* CTA */}
              <div className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white rounded-xl p-6">
                <p className="text-2xl font-bold">
                  <span className="hidden sm:inline">이 모든 노하우를 무료 전자책에 담았습니다.</span>
                  <span className="sm:hidden">
                    이 모든 노하우를<br />
                    무료 전자책에 담았습니다.
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 피터 드러커 인용문 섹션 */}
      <section className="py-20 bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white relative overflow-hidden">
        {/* 배경 장식 */}
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-20 right-20 w-96 h-96 bg-blue-500 rounded-full filter blur-3xl"></div>
          <div className="absolute bottom-20 left-20 w-96 h-96 bg-indigo-600 rounded-full filter blur-3xl"></div>
        </div>

        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative">
          {/* 피터 드러커 이미지 */}
          <div className="mb-12">
            <div className="w-48 h-36 bg-gray-700 rounded-full mx-auto flex items-center justify-center shadow-2xl overflow-hidden">
              <img
                src={peterDruckerImage}
                alt="피터 드러커"
                className="w-full h-full object-cover rounded-full"
              />
            </div>
            <p className="text-center mt-4 text-gray-400">[경영학의 아버지 피터 드러커]</p>
          </div>

          {/* 소개 */}
          <div className="text-center mb-12">
            <p className="text-xl text-gray-300 mb-2">경영학의 아버지라 불리는</p>
            <h3 className="text-3xl font-bold">피터 드러커는</h3>
            <p className="text-xl text-gray-300 mt-2">이런 말을 했습니다.</p>
          </div>

          {/* 명언 - 큰 따옴표와 함께 */}
          <div className="relative mb-16">
            <div className="absolute -top-8 -left-4 text-8xl text-gray-700 opacity-50">"</div>
            <div className="absolute -bottom-8 -right-4 text-8xl text-gray-700 opacity-50 rotate-180">"</div>

            <blockquote className="text-center relative z-10">
              <p className="text-[28px] sm:text-3xl md:text-4xl font-light italic leading-relaxed mb-4">
                측정하지 않으면 관리할 수 없으며
              </p>
              <p className="text-[28px] sm:text-3xl md:text-4xl font-light italic leading-relaxed">
                관리할 수 없으면 개선할 수도 없다
              </p>
            </blockquote>
          </div>

          {/* 구분선 */}
          <div className="flex items-center justify-center mb-12">
            <div className="w-24 h-1 bg-gradient-to-r from-transparent via-gray-600 to-transparent"></div>
          </div>

          {/* 해석과 연결 */}
          <div className="space-y-8 text-center">
            <p className="text-xl text-gray-300">
              <span className="hidden sm:inline">
                피터 드러커의 이 말은 데이터 기반 퍼포먼스 마케팅과<br />
                A/B 테스트의 핵심을 그대로 관통합니다.
              </span>
              <span className="sm:hidden">
                피터 드러커의 이 말은 데이터 기반<br />
                퍼포먼스 마케팅과 A/B 테스트의<br />
                핵심을 그대로 관통합니다.
              </span>
            </p>

            <div className="bg-gradient-to-r from-blue-600/20 to-indigo-600/20 backdrop-blur-sm rounded-2xl p-8 border border-gray-700">
              <p className="text-2xl font-bold mb-4">
                이것이 바로 제가 전환율을 <span className="text-green-400">4.3%</span>까지 끌어올린 비밀입니다.
              </p>

              <div className="flex justify-center items-center space-x-8 my-8">
                <div className="text-center">
                  <div className="w-16 h-16 bg-blue-500/20 rounded-full flex items-center justify-center mx-auto mb-2">
                    <BarChart2 className="w-8 h-8 text-blue-400" />
                  </div>
                  <p className="text-lg font-semibold">
                    <span className="hidden sm:inline">측정하고</span>
                    <span className="sm:hidden">측정</span>
                  </p>
                </div>
                <ArrowRight className="w-6 h-6 text-gray-600" />
                <div className="text-center">
                  <div className="w-16 h-16 bg-green-500/20 rounded-full flex items-center justify-center mx-auto mb-2">
                    <Target className="w-8 h-8 text-green-400" />
                  </div>
                  <p className="text-lg font-semibold">
                    <span className="hidden sm:inline">테스트하고</span>
                    <span className="sm:hidden">테스트</span>
                  </p>
                </div>
                <ArrowRight className="w-6 h-6 text-gray-600" />
                <div className="text-center">
                  <div className="w-16 h-16 bg-yellow-500/20 rounded-full flex items-center justify-center mx-auto mb-2">
                    <TrendingUp className="w-8 h-8 text-yellow-400" />
                  </div>
                  <p className="text-lg font-semibold">
                    <span className="hidden sm:inline">개선하는 것</span>
                    <span className="sm:hidden">개선</span>
                  </p>
                </div>
              </div>
            </div>

            <p className="text-xl font-bold text-gray-200">
              <span className="hidden sm:inline">
                바로 이 원리를 가장 잘 구현한, 폭발적인 성과를 만드는<br />
                마케팅 방법이 <span className="text-blue-400">퍼포먼스 마케팅</span>과 <span className="text-blue-400">A/B 테스트</span>입니다.
              </span>
              <span className="sm:hidden">
                바로 이 원리를 가장 잘 구현한,<br />
                폭발적인 성과를 만드는 마케팅 방법이<br />
                <span className="text-blue-400">퍼포먼스 마케팅</span>과 <span className="text-blue-400">A/B 테스트</span>입니다.
              </span>
            </p>
          </div>
        </div>
      </section>

      {/* 경력 및 경험 섹션 */}
      <section className="py-20 bg-gradient-to-br from-blue-50 via-white to-purple-50">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold mb-4">
              8년간의 퍼포먼스 마케팅 여정
            </h2>

            <p className="text-xl text-gray-600">
              <span className="hidden sm:inline">2017년부터 지금까지, 끊임없이 테스트하고 성장해왔습니다</span>
              <span className="sm:hidden">
                2017년부터 지금까지, 끊임없이 테스트하고<br />
                성장해왔습니다
              </span>
            </p>
          </div>

          {/* 경력 타임라인 */}
          <div className="relative mb-16">
            {/* 중앙 라인 */}
            <div className="absolute left-1/2 transform -translate-x-1/2 w-1 h-full bg-gradient-to-b from-blue-300 to-purple-300"></div>

            <div className="space-y-12">
              {/* 2017년 시작 */}
              <div className="relative flex items-center">
                <div className="flex-1 text-right pr-8">
                  <div className="inline-block bg-white rounded-xl shadow-lg p-6 border-2 border-blue-200">
                    <h3 className="text-xl font-bold text-blue-600 mb-2">2017년 시작</h3>
                    <p className="text-gray-700">광고대행사</p>
                  </div>
                </div>
                <div className="absolute left-1/2 transform -translate-x-1/2 w-4 h-4 bg-blue-500 rounded-full border-4 border-white"></div>
                <div className="flex-1"></div>
              </div>

              {/* 다양한 경험 */}
              <div className="relative flex items-center">
                <div className="flex-1"></div>
                <div className="absolute left-1/2 transform -translate-x-1/2 w-4 h-4 bg-purple-500 rounded-full border-4 border-white"></div>
                <div className="flex-1 pl-8">
                  <div className="inline-block bg-white rounded-xl shadow-lg p-6 border-2 border-purple-200">
                    <h3 className="text-xl font-bold text-purple-600 mb-2">
                      <span className="hidden sm:inline">다양한 역할 수행</span>
                      <span className="sm:hidden">다양한 경험</span>
                    </h3>
                    <div className="space-y-1 text-gray-700">
                      <p>• 인하우스 마케터</p>
                      <p>• 프리랜서</p>
                      <p>• 마케팅 교육</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* 현재 */}
              <div className="relative flex items-center">
                <div className="flex-1 text-right pr-8">
                  <div className="inline-block bg-gradient-to-r from-yellow-50 to-orange-50 rounded-xl shadow-lg p-6 border-2 border-orange-200">
                    <h3 className="text-xl font-bold text-orange-600 mb-2">현재</h3>
                    <p className="text-gray-700">
                      <span className="hidden sm:inline">마케팅 솔루션 서비스 운영</span>
                      <span className="sm:hidden">마케팅 솔루션 운영</span>
                    </p>
                  </div>
                </div>
                <div className="absolute left-1/2 transform -translate-x-1/2 w-4 h-4 bg-orange-500 rounded-full border-4 border-white"></div>
                <div className="flex-1"></div>
              </div>
            </div>
          </div>

          {/* 경험 업종 */}
          <div className="bg-white rounded-3xl shadow-xl p-10 border-2 border-gray-100">
            <h3 className="text-2xl font-bold text-center mb-8">
              다양한 업종에서 검증된 노하우
            </h3>

            <div className="grid md:grid-cols-3 gap-6">
              <div className="text-center p-6 bg-blue-50 rounded-xl">
                <Building2 className="w-12 h-12 text-blue-600 mx-auto mb-3" />
                <h4 className="font-bold text-lg mb-2">대기업</h4>
                <p className="text-gray-600">요기요, 쿠첸 등<br />대규모 캠페인 운영</p>
              </div>

              <div className="text-center p-6 bg-green-50 rounded-xl">
                <Rocket className="w-12 h-12 text-green-600 mx-auto mb-3" />
                <h4 className="font-bold text-lg mb-2">스타트업</h4>
                <p className="text-gray-600">빠른 성장을 위한<br />애자일 마케팅</p>
              </div>

              <div className="text-center p-6 bg-purple-50 rounded-xl">
                <Store className="w-12 h-12 text-purple-600 mx-auto mb-3" />
                <h4 className="font-bold text-lg mb-2">소상공인</h4>
                <p className="text-gray-600">예산 효율적인<br />성과 창출</p>
              </div>
            </div>

            <div className="mt-8 text-center">
              <p className="text-xl font-semibold text-gray-700">
                <span className="hidden sm:inline">
                  꾸준히 <span className="text-blue-600">퍼포먼스 마케팅</span>과 <span className="text-blue-600">A/B 테스트</span>를 해왔습니다.
                </span>
                <span className="sm:hidden">
                  꾸준히 <span className="text-blue-600">퍼포먼스 마케팅</span>과<br />
                  <span className="text-blue-600">A/B 테스트</span>를 해왔습니다.
                </span>
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* 개인 성과 및 가치 제안 섹션 */}
      <section className="py-20 bg-gradient-to-br from-gray-900 via-gray-800 to-blue-900 text-white relative overflow-hidden">
        {/* 배경 장식 */}
        <div className="absolute inset-0 opacity-20">
          <div className="absolute top-20 right-20 w-64 h-64 bg-yellow-500 rounded-full filter blur-3xl"></div>
          <div className="absolute bottom-20 left-20 w-64 h-64 bg-green-500 rounded-full filter blur-3xl"></div>
        </div>

        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative">
          {/* 연봉 상승 스토리 */}
          <div className="text-center mb-16">
            <div className="inline-block bg-gradient-to-r from-yellow-400 to-orange-400 px-6 py-3 rounded-full mb-8">
              <span className="text-gray-900 font-bold text-lg">💰 실제 사례</span>
            </div>

            <h2 className="text-[26px] sm:text-3xl md:text-4xl font-bold mb-8 leading-tight">
              인하우스 마케터로 일할 당시,<br />
              퍼포먼스 마케팅의 성과와 역량으로<br className="hidden sm:inline" />
              <span className="block sm:hidden mb-4"></span>
              <span className="text-[40px] sm:text-5xl text-yellow-400">입사 3개월 만에 연봉 60%를 올렸습니다.</span>
            </h2>
          </div>

          {/* 이미지 플레이스홀더 */}
          <div className="space-y-6 mb-16">
            <div className="bg-gray-800 rounded-xl p-4 flex items-center justify-center h-84 shadow-2xl overflow-hidden">
              {/* 데스크톱용 이미지 */}
              <img
                src={salaryBefore}
                alt="연봉 상승 전 성과"
                className="hidden sm:block w-full h-full object-cover rounded-lg"
              />
              {/* 모바일용 이미지 */}
              <img
                src={salaryBeforeMobile}
                alt="연봉 상승 전 성과"
                className="block sm:hidden w-full h-full object-contain rounded-lg"
              />
            </div>
            <p className="text-center mt-4 text-gray-400">
              2022년 3월 23일 입사, 3,200만 원 연봉 계약서
            </p>
            <div className="bg-gray-800 rounded-xl p-4 flex items-center justify-center h-84 shadow-2xl overflow-hidden">
              {/* 데스크톱용 이미지 */}
              <img
                src={salaryAfter}
                alt="연봉 상승 후 성과"
                className="hidden sm:block w-full h-full object-cover rounded-lg"
              />
              {/* 모바일용 이미지 */}
              <img
                src={salaryAfterMobile}
                alt="연봉 상승 후 성과"
                className="block sm:hidden w-full h-full object-contain rounded-lg"
              />
            </div>
            <p className="text-center mt-4 text-gray-400">
              2022년 7월 중순 연봉 협상, 5,000만 원 연봉 계약서<br />
              <span className="text-sm">(연봉 계약서는 다음 달 1일에 작성)</span>
            </p>
          </div>

          {/* 비밀 공개 */}
          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-10 mb-16 border border-white/20">
            <p className="text-xl mb-6">
              제가 단기간에 이런 성과를 낼 수 있었던 것은 단순히 운이 좋아서가 아니었습니다.
            </p>
            <p className="text-2xl font-bold text-center">
              <span className="text-blue-400">데이터로 성과를 증명</span>하고,<br />
              <span className="text-green-400">저의 가치를 스스로 끌어올리는 방법</span>을 알았기 때문입니다.
            </p>
          </div>

          {/* 독자에게 질문 */}
          <div className="text-center space-y-8">
            <p className="text-2xl">혹시 여러분도</p>

            <div className="grid md:grid-cols-3 gap-6 max-w-4xl mx-auto">
              <div className="bg-gradient-to-br from-red-500/20 to-orange-500/20 backdrop-blur-sm rounded-xl p-6 border border-red-400/30">
                <div className="text-4xl mb-3">💥</div>
                <p className="text-xl font-bold">
                  <span className="hidden sm:inline">폭발적인 매출</span>
                  <span className="sm:hidden">폭발적인 매출을 만들고</span>
                </p>
                <p className="text-gray-300 hidden sm:block">을 만들고</p>
              </div>
              <div className="bg-gradient-to-br from-blue-500/20 to-purple-500/20 backdrop-blur-sm rounded-xl p-6 border border-blue-400/30">
                <div className="text-4xl mb-3">🏆</div>
                <p className="text-xl font-bold">
                  <span className="hidden sm:inline">회사에서 인정</span>
                  <span className="sm:hidden">회사에서 인정받으며</span>
                </p>
                <p className="text-gray-300 hidden sm:block">받으며</p>
              </div>
              <div className="bg-gradient-to-br from-green-500/20 to-emerald-500/20 backdrop-blur-sm rounded-xl p-6 border border-green-400/30">
                <div className="text-4xl mb-3">🚀</div>
                <p className="text-xl font-bold">
                  <span className="hidden sm:inline">대체 불가능한</span>
                  <span className="sm:hidden">대체 불가능한 마케팅 역량을</span>
                </p>
                <p className="text-gray-300 hidden sm:block">마케팅 역량을</p>
              </div>
            </div>

            <p className="text-2xl">
              갖고 싶다는 고민을 하고 계신가요?
            </p>
          </div>

          {/* CTA */}
          <div className="mt-16 text-center">
            <div className="bg-gradient-to-r from-yellow-400 to-orange-500 p-1 rounded-2xl inline-block">
              <div className="bg-gray-900 rounded-xl px-10 py-8">
                <h3 className="text-3xl font-bold mb-4">
                  그렇다면 제가 그 방법을 알려드리겠습니다.
                </h3>
                <p className="text-lg sm:text-xl text-gray-300">
                  <span className="hidden sm:inline">
                    제가 8년간의 경험을 통해 직접 증명해 온,<br />
                    성과를 만드는 퍼포먼스 마케팅과 A/B 테스트의 모든 것을<br />
                    <span className="text-yellow-400 font-bold">무료 전자책</span>을 통해 얻어 가실 수 있습니다.
                  </span>
                  <span className="sm:hidden">
                    제가 8년간의 경험을 통해 직접 증명해 온<br />
                    성과를 만드는 퍼포먼스 마케팅과<br />
                    A/B 테스트의 모든 것을<br />
                    <span className="text-yellow-400 font-bold">무료 전자책</span>을 통해 얻어 가실 수 있습니다
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 최종 가치 제안 섹션 */}
      <section className="py-20 bg-gradient-to-b from-white to-gray-50">

        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* 메인 메시지 */}
          <div className="text-center mb-12 sm:mb-16">
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold">
              <div className="mb-3 sm:mb-4">
                <span className="hidden sm:inline">퍼포먼스 마케팅과 A/B 테스트의 기초부터</span>
                <span className="sm:hidden">
                  퍼포먼스 마케팅과<br />
                  A/B 테스트의 기초부터
                </span>
              </div>
              <div>
                <span className="bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent">
                  <span className="hidden sm:inline">폭발적인 매출을 만드는 노하우</span>
                  <span className="sm:hidden">
                    폭발적인 매출을<br />
                    만드는 노하우를
                  </span>
                </span>
                <span className="hidden sm:inline">공개합니다.</span>
                <span className="sm:hidden block mt-2">공개합니다.</span>
              </div>
            </h2>
          </div>

          {/* 경고 메시지 - 모바일 최적화 */}
          <div className="relative mb-12 sm:mb-16">
            {/* 데스크톱용 - 기존 디자인 */}
            <div className="hidden sm:block">
              <div className="absolute -inset-4 bg-gradient-to-r from-red-100 to-orange-100 rounded-3xl opacity-50"></div>
              <div className="relative bg-white rounded-2xl shadow-xl p-10 border-2 border-orange-200">
                <div className="flex items-start mb-6">
                  <div className="flex-shrink-0 mr-4">
                    <div className="w-12 h-12 bg-orange-100 rounded-full flex items-center justify-center">
                      <AlertCircle className="w-6 h-6 text-orange-600" />
                    </div>
                  </div>
                  <div className="flex-grow">
                    <h3 className="text-xl font-bold mb-3 text-gray-900">
                      이런 분들에게는 맞지 않을 수 있습니다
                    </h3>
                    <p className="text-lg text-gray-700">
                      만약 단순히 <span className="font-semibold text-gray-900">'광고 매체를 운영하는 기술'</span>이나
                      단기적인 성과를 내는 비법을 기대하셨다면, 이 전자책은 맞지 않을 수 있습니다.
                    </p>
                  </div>
                </div>

                <div className="bg-gray-50 rounded-xl p-6">
                  <p className="text-lg text-gray-700">
                    그런 단편적인 지식이 아닌, <span className="font-bold text-blue-600">데이터를 활용해 비즈니스를
                      근본적으로 성장시키는 '원리'</span>에 대해 이야기할 것이기 때문입니다.
                  </p>
                </div>
              </div>
            </div>

            {/* 모바일용 - 간소화된 디자인 */}
            <div className="sm:hidden">
              <div className="bg-orange-50 rounded-2xl p-6 border-2 border-orange-200">
                <div className="text-center mb-4">
                  <div className="w-10 h-10 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-3">
                    <AlertCircle className="w-5 h-5 text-orange-600" />
                  </div>
                  <h3 className="text-lg font-bold text-gray-900 mb-3">
                    이런 분들에게는<br />
                    맞지 않을 수 있습니다
                  </h3>
                </div>

                <div className="space-y-4 text-center">
                  <p className="text-[16px] text-gray-700">
                    만약 단순히 <span className="font-semibold text-gray-900">'광고 매체를 운영하는 기술'</span>이나<br />
                    단기적인 성과를 내는 비법을<br />
                    기대하셨다면, 이 전자책은<br />
                    맞지 않을 수 있습니다.
                  </p>

                  <div className="bg-blue-50 rounded-lg p-4 mt-4">
                    <p className="text-[16px] text-blue-800">
                      <span className="font-bold">데이터를 활용해 비즈니스를<br />
                        근본적으로 성장시키는 '원리'</span>에<br />
                      대해 이야기할 것이기 때문입니다.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>


          {/* 타겟 독자 명확화 */}
          <div className="text-center">
            <div className="inline-block">
              <div className="bg-gradient-to-r from-blue-600 to-indigo-600 p-1 rounded-3xl">
                <div className="bg-white rounded-2xl px-10 py-8">
                  <p className="text-xl mb-6 text-gray-700">따라서,</p>

                  <div className="flex items-center justify-center mb-6">
                    <div className="text-center px-3 sm:px-6">
                      <div className="text-4xl mb-2">🎯</div>
                      <p className="text-base sm:text-lg text-gray-500 line-through whitespace-nowrap">'감'이 아닌</p>
                    </div>
                    <ArrowRight className="w-6 sm:w-8 h-6 sm:h-8 text-gray-400 mx-2 sm:mx-4 flex-shrink-0" />
                    <div className="text-center px-3 sm:px-6">
                      <div className="text-4xl mb-2">📊</div>
                      <p className="text-base sm:text-lg font-bold text-blue-600 whitespace-nowrap">'데이터'로</p>
                    </div>
                  </div>


                  <p className="text-xl sm:text-2xl font-bold text-gray-900 mb-4">
                    <span className="hidden sm:inline">진짜 성과를 만드는 본질적인 마케팅 방법을</span>
                    <span className="sm:hidden">
                      진짜 성과를 만드는<br />
                      본질적인 마케팅 방법을
                    </span>
                  </p>
                  <p className="text-xl sm:text-2xl font-bold text-gray-900 mb-6 sm:mb-8">
                    <span className="hidden sm:inline">배우고 싶은 분들에게만</span>
                    <span className="sm:hidden">배우고 싶은 분들에게만</span>
                  </p>

                  <p className="text-2xl sm:text-3xl font-bold bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent">
                    <span className="hidden sm:inline">이 전자책을 추천합니다.</span>
                    <span className="sm:hidden">
                      이 전자책을<br />
                      추천합니다.
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* 최종 CTA 버튼 */}
          <div className="mt-12 text-center">
            <button
              onClick={() => document.getElementById('ebook-form').scrollIntoView({ behavior: 'smooth' })}
              className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white px-10 py-4 rounded-full font-bold text-lg hover:shadow-2xl transition-all duration-300 transform hover:scale-105"
            >
              지금 무료로 받아보기 →
            </button>
          </div>
        </div>
      </section>

      {/* 최종 CTA 섹션 - 강화된 버전 */}   {/* 최종 CTA 섹션 - 이메일 발송 안내 추가 */}
      <section id="ebook-form" className="py-20 bg-gradient-to-br from-blue-600 to-indigo-600 text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">

            <h2 className="text-4xl md:text-5xl font-bold mb-6">
              지금이 기회입니다
            </h2>
            <p className="text-[19px] sm:text-xl mb-4">
              1,441명의 마케터가 이미 성과를 만들고 있습니다.<br />
              다음은 여러분 차례입니다
            </p>



          </div>

          {/* 폼 - 개선된 디자인 */}
          <div className="bg-white rounded-3xl p-8 md:p-10 text-gray-900 max-w-2xl mx-auto shadow-2xl">
            <div className="text-center mb-8">
              <h3 className="text-2xl font-bold mb-2">
                무료 전자책 받기
              </h3>
              {/* 이메일 발송 안내 추가 */}
              <div className="bg-blue-50 rounded-lg px-4 py-2 inline-flex items-center mt-4">
                <Mail className="w-5 h-5 text-blue-600 mr-2" />
                <span className="text-sm text-blue-800 font-medium">
                  입력하신 이메일로 전자책이 즉시 발송됩니다
                </span>
              </div>
            </div>

            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label className="block text-sm font-medium mb-2">
                  회사명 <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  required
                  className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                  placeholder="회사명을 입력하세요"
                  value={formData.company}
                  onChange={(e) => setFormData({ ...formData, company: e.target.value })}
                />
              </div>

              <div>
                <label className="block text-sm font-medium mb-2">
                  이름 <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  required
                  className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                  placeholder="홍길동"
                  value={formData.name}
                  onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                />
              </div>

              <div>
                <label className="block text-sm font-medium mb-2">
                  이메일 <span className="text-red-500">*</span>
                </label>
                <input
                  type="email"
                  required
                  className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                  placeholder="your@email.com"
                  value={formData.email}
                  onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                />
                {/* 이메일 필드 아래 추가 안내 */}
                <p className="text-xs text-gray-500 mt-1">
                  <span className="hidden sm:inline">* 정확한 이메일 주소를 입력해주세요. 전자책이 이 주소로 발송됩니다.</span>
                  <span className="sm:hidden">
                    * 정확한 이메일 주소를 입력해주세요.<br />
                    전자책이 이 주소로 발송됩니다.
                  </span>
                </p>
              </div>

              {/* 개인정보 및 마케팅 통합 동의 - 필수 */}
              <div className="mt-4">
                <label className="flex items-start">
                  <input
                    type="checkbox"
                    required
                    className="mt-1 mr-3 h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                    checked={formData.agreeToTerms}
                    onChange={(e) => setFormData({ ...formData, agreeToTerms: e.target.checked })}
                  />
                  <span className="text-[13px] sm:text-sm text-gray-600">
                    <Link to="/privacy" className="text-blue-600 hover:underline">
                      개인정보 처리방침
                    </Link> 및
                    <button
                      type="button"
                      onClick={() => setShowMarketingModal(true)}
                      className="text-blue-600 hover:underline ml-1"
                    >
                      마케팅 정보 수신
                    </button>
                    에 동의합니다 <span className="text-red-500">*</span>
                    <span className="block text-xs text-gray-500 mt-1">
                      전자책 발송을 위해 필수로 동의가 필요합니다.
                    </span>
                  </span>
                </label>
              </div>

              <button
                type="submit"
                className="w-full bg-gradient-to-r from-blue-600 to-indigo-600 text-white py-4 rounded-lg font-bold text-lg hover:shadow-lg transition-all duration-300 flex items-center justify-center group relative overflow-hidden"
              >
                <span className="relative z-10 flex items-center">
                  지금 이메일로 받기
                  <ArrowRight className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform" />
                </span>
                <div className="absolute inset-0 bg-gradient-to-r from-indigo-600 to-purple-600 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              </button>

              {/* 추가 혜택 표시 - 첫 번째 항목 수정 */}
              <div className="grid grid-cols-2 gap-4 mt-6">
                <div className="flex items-center text-sm text-gray-600">
                  <Mail className="w-4 h-4 text-green-500 mr-2" />
                  이메일로 즉시 발송
                </div>

              </div>
            </form>

          </div>

          {/* 마케팅 정보 수신 동의 모달 */}
          {
            showMarketingModal && (
              <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
                <div className="bg-white rounded-2xl max-w-2xl w-full max-h-[90vh] overflow-hidden flex flex-col">
                  {/* 모달 헤더 */}
                  <div className="p-6 border-b border-gray-200">
                    <div className="flex items-center justify-between">
                      <h3 className="text-2xl font-bold text-gray-900">마케팅 정보 수신 동의</h3>
                      <button
                        onClick={() => setShowMarketingModal(false)}
                        className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
                      >
                        <X className="w-6 h-6 text-gray-500" />
                      </button>
                    </div>
                  </div>

                  {/* 모달 내용 */}
                  <div className="p-6 overflow-y-auto flex-1">
                    <div className="space-y-6">
                      {/* 수집 항목 */}
                      <div>
                        <h4 className="text-lg font-semibold mb-3 flex items-center text-gray-900">
                          <Database className="w-5 h-5 mr-2 text-blue-600" />
                          수집하는 개인정보 항목
                        </h4>
                        <div className="bg-gray-50 rounded-lg p-4">
                          <ul className="space-y-2 text-gray-700">
                            <li className="flex items-start">
                              <CheckCircle className="w-4 h-4 text-green-500 mr-2 mt-0.5 flex-shrink-0" />
                              <span>이메일 주소</span>
                            </li>
                            <li className="flex items-start">
                              <CheckCircle className="w-4 h-4 text-green-500 mr-2 mt-0.5 flex-shrink-0" />
                              <span>이름</span>
                            </li>
                            <li className="flex items-start">
                              <CheckCircle className="w-4 h-4 text-green-500 mr-2 mt-0.5 flex-shrink-0" />
                              <span>회사명</span>
                            </li>
                          </ul>
                        </div>
                      </div>

                      {/* 이용 목적 */}
                      <div>
                        <h4 className="text-lg font-semibold mb-3 flex items-center text-gray-900">
                          <Target className="w-5 h-5 mr-2 text-blue-600" />
                          개인정보 이용 목적
                        </h4>
                        <div className="bg-blue-50 rounded-lg p-4">
                          <ul className="space-y-2 text-gray-700">
                            <li className="flex items-start">
                              <CheckCircle className="w-4 h-4 text-blue-500 mr-2 mt-0.5 flex-shrink-0" />
                              <span>전자책 및 마케팅 자료 발송</span>
                            </li>
                            <li className="flex items-start">
                              <CheckCircle className="w-4 h-4 text-blue-500 mr-2 mt-0.5 flex-shrink-0" />
                              <span>서비스 및 이벤트 안내</span>
                            </li>
                          </ul>
                        </div>
                      </div>

                      {/* 보유 기간 */}
                      <div>
                        <h4 className="text-lg font-semibold mb-3 flex items-center text-gray-900">
                          <Clock className="w-5 h-5 mr-2 text-blue-600" />
                          개인정보 보유 및 이용 기간
                        </h4>
                        <div className="bg-yellow-50 rounded-lg p-4">
                          <p className="text-gray-700">
                            <span className="font-semibold">수신 동의 철회 시까지</span>
                          </p>
                        </div>
                      </div>

                      {/* 수신 거부 권리 */}
                      <div>
                        <h4 className="text-lg font-semibold mb-3 flex items-center text-gray-900">
                          <Shield className="w-5 h-5 mr-2 text-blue-600" />
                          수신 거부 안내
                        </h4>
                        <div className="bg-green-50 rounded-lg p-4">
                          <p className="text-gray-700">
                            언제든지 수신 거부가 가능하며, 모든 이메일에 수신 거부 링크가 포함됩니다.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* 모달 푸터 */}
                  <div className="p-6 border-t border-gray-200 bg-gray-50">
                    <div className="flex items-center justify-between">
                      <p className="text-sm text-gray-600">
                        위 내용을 확인하였으며, 마케팅 정보 수신에 동의합니다.
                      </p>
                      <button
                        onClick={() => {
                          setFormData({ ...formData, agreeToTerms: true });
                          setShowMarketingModal(false);
                        }}
                        className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-medium"
                      >
                        확인
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )
          }

          {/* 마지막 설득 메시지 */}
          <div className="text-center mt-12 space-y-4">
            <p className="text-xl font-semibold">
              "지식에 투자하는 것이 최고의 이자를 낳는다"
            </p>
            <p className="text-lg">
              - 벤자민 프랭클린
            </p>
          </div>
        </div >
      </section >

      <Footer />

      {/* 플로팅 CTA 버튼 - 개선된 버전 */}
      <div className={`fixed bottom-6 right-6 z-40 transition-all duration-300 ${scrolled ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
        <button
          onClick={() => document.getElementById('ebook-form').scrollIntoView({ behavior: 'smooth' })}
          className="bg-gradient-to-r from-yellow-400 to-orange-500 text-gray-900 px-6 py-3 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 flex items-center group font-bold animate-bounce"
        >
          <Gift className="w-5 h-5 mr-2" />
          <span>무료 전자책 받기</span>
          <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" />
        </button>
      </div>

    </div >
  );
};

export default AbtestEbookLandingPage;